import React from 'react'
import Transition from 'react-transition-group/Transition'

const duration = 150

const defaultStyle = {
  transition: `opacity ${duration}ms linear`,
  opacity: 0,
  display: 'none'
}

const transitionStyles = {
  entering: { opacity: 0, display:'block' },
  entered:  { opacity: 1, display:'block' },
}

export const Fade = ( { in: inProp , ...props } ) => (
  <Transition in={inProp} timeout={duration}>
    {( state ) => (
      <div className={props.className} style={{
        ...defaultStyle,
        ...transitionStyles[state]
      }}>
        {props.children}
      </div>
    )}
  </Transition>
)


// WEBPACK FOOTER //
// ./src/components/animations/Fade.js